import { createReducer, on } from '@ngrx/store';
import * as fromWeightActions from '../actions/weights.actions';
import { WeightFirebaseResponse } from '../../models/weights.model';

export interface WeightState {
    data: WeightFirebaseResponse;
    loaded: boolean;
    loading: boolean;
    error: string;
}

export const initialState: WeightState = {
    data: undefined as any,
    loaded: false,
    loading: false,
    error: ''
};

export const weightReducer = createReducer(
    initialState,
    on(fromWeightActions.LoadWeightAction, (state) => ({ ...state, loading: true })),
    on(fromWeightActions.LoadWeightSuccessAction, (state, { data }) => ({ ...state, data, loaded: true, loading: false })),
    on(fromWeightActions.LoadWeightFailAction, (state, { error }) => ({ ...state, error: error.message })),
    on(fromWeightActions.AddWeightAction, (state) => ({ ...state, loading: true })),
    on(fromWeightActions.AddWeightSuccessAction, (state, { data }) => ({ ...state, data, loaded: true, loading: false })),
    on(fromWeightActions.AddWeightFailAction, (state, { error }) => ({ ...state, error: error.message })),
    on(fromWeightActions.UpdateWeightAction, (state) => ({ ...state, loading: true })),
    on(fromWeightActions.UpdateWeightSuccessAction, (state, { data }) => ({ ...state, data: { ...state.data, weights: data.weights }, loaded: true, loading: false })),
    on(fromWeightActions.UpdateWeightFailAction, (state, { error }) => ({ ...state, error: error.message })),
);
